import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M25.385 41.943a.999.999 0 1 0-.023 1.997q.513.006 1.032.006 9.976.002 16.802-2.128a3.995 3.995 0 0 0 2.75-4.469l-.843-5.066a6.99 6.99 0 0 0-6.293-5.818q-5.724-.495-12.416-.496-.534 0-1.06.003a.999.999 0 0 0 .011 1.998q.522-.003 1.05-.003 6.607 0 12.243.488a4.994 4.994 0 0 1 4.495 4.156l.842 5.066a2 2 0 0 1-1.375 2.234q-6.51 2.036-16.206 2.038-.508 0-1.009-.006m-6.518-29.956a7.99 7.99 0 0 0 7.99 7.99 7.99 7.99 0 0 0 7.99-7.99 7.99 7.99 0 0 0-7.99-7.99 7.99 7.99 0 0 0-7.99 7.99m-1.997 0C16.87 6.471 21.34 2 26.857 2c5.516 0 9.987 4.47 9.987 9.987 0 5.516-4.47 9.987-9.987 9.987-5.516 0-9.987-4.47-9.987-9.987M3.997 34.957a8.99 8.99 0 0 0 8.989 8.989 8.99 8.99 0 0 0 8.988-8.988 8.99 8.99 0 0 0-8.988-8.989 8.99 8.99 0 0 0-8.989 8.989m-1.997 0c0-6.067 4.918-10.985 10.986-10.985s10.986 4.917 10.986 10.986c0 6.067-4.918 10.985-10.986 10.985S2 41.026 2 34.958m12.973.931-2.278 2.305a.963.963 0 0 0 .014 1.37.98.98 0 0 0 1.38-.013l3.907-3.952a.964.964 0 0 0-.007-1.364l-3.906-3.875a.98.98 0 0 0-1.381 0 .963.963 0 0 0 0 1.37l2.239 2.221H8.386c-.41 0-.744.434-.744.97 0 .534.333.968.744.968z",
      clipRule: "evenodd"
    }
  )
);
var SvgAssignedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AssignedOutlined_default = SvgAssignedOutlined;

export { AssignedOutlined_default as default };
